import { Inject, Injectable } from "@angular/core";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { BaseFpxComponentState, BaseFpxFormHelper, HttpRequest } from "@fpx/core";
import { CommonService } from "src/app/common.service";
import { IPopupScreenData } from "src/app/common/models/popup-screen-data.model";
import { ProcessShellService } from "src/app/process-shell/services/process-shell.service";
import { environment } from "src/environments/environment";
import { TransfersResultPageComponent } from "./transfers-result-page.component";
import { HttpProviderService } from  '@fpx/core';
import { TransfersResultPageService } from "./services/transfers-result-page.service";
import { FileOpenerService } from "src/app/services/mobile/file-opener.service";
import { BeneficiariesService } from "src/app/transfers/beneficiaries-service/beneficiaries.service";

export class TransfersResultPageState extends BaseFpxComponentState {
  showSuggestion: boolean = false;
  resultData: any;
  favouriteEnable: boolean = true;
  closeBtnLable: string;
  hideDownload: boolean = false;
  tranInternationalRefNo: string = "";
}

@Injectable()
export class TransfersResultPageHelper extends BaseFpxFormHelper<TransfersResultPageState>{
  private accountsModules: string[] = ['casa-accounts', 'deposits', 'loans'];
  private cardsModules: string[] = ['debit-card', 'credit-card'];
  private commonModules = new Map<any,any>()

  constructor(
    public _httpProvider : HttpProviderService,
    private _processShellService: ProcessShellService,
    private _router: Router,
    public transfersResultPageService:TransfersResultPageService,
    private _transfersResultPageService: TransfersResultPageService,
    private _matDialog: MatDialog,
    private _commonService: CommonService,
    private _fileOpner: FileOpenerService,
    public beneficiariesService: BeneficiariesService,
    

    @Inject(MAT_DIALOG_DATA) private data: IPopupScreenData
  ) {
    super(new TransfersResultPageState());
    // this.state.resultData = this._commonService.isDesktop()?this.data:this._router.getCurrentNavigation()?.extras?.queryParams;
    this.state.resultData = this._router.getCurrentNavigation()?.extras?.queryParams;

    this.commonModules.set('bill-payments','payments')
  }

  public doPreInit(): void {
    this._processShellService.formClassName = this._processShellService.formClassName + " result-info";
    this._processShellService.setFooterVisible(false);
    this._processShellService.setHeaderBackbtnVisible(false);
    // this._processShellService.setTitle('');
    var appID = '';
    if(this.state.resultData.message.includes('|')) {
      appID= this.state.resultData.message.split('|')[1];
      this.state.resultData.message =this.state.resultData.message.split('|')[0];
      var internationalID = this.state?.resultData?.message?.split(' ')?.slice(0,1)?.join('+');
    }
      var internationalID = this.state?.resultData?.message?.split(' ')?.slice(0,1)?.join('+');
        if(appID== 'MANAGEPAYID' || appID== 'GENPAYID') {
          this.state.hideDownload = false;
        } else if(internationalID == 'International' && this.state?.resultData?.message?.includes('beneficiary')) {
          this.state.hideDownload = false;
        }  else {
          this.state.hideDownload = true;
        }
        if(this.beneficiariesService?.internationalTranDetails?.transferService == 'TRANINTERNATIONAL'){
          this._transfersResultPageService.findByTranInternationalRefNo(this.state.resultData.processId).subscribe((res)=>{
          this._commonService.hideSpinner();
          this.state.tranInternationalRefNo=res.body.transferData.externalRef


          },
            (reason) => {
            this._commonService.hideSpinner();
          })
        }
        // else if(internationalID == 'International') {
        //   this.state.hideDownload = false;
        // } 
  }
  public doPostInit(): void {
    this._commonService.hideSpinner();
    this.closeBtnLable();

  }

  public doDestroy(): void {
    this._processShellService.closeNavigation = []
    this.transfersResultPageService.resultSubmittedData = []
    this.transfersResultPageService.scheduleId = undefined;
    this.state.favouriteEnable = true;
    this._processShellService.resultIconData =  undefined;
    this._processShellService.formClassName = this._processShellService.formClassName.replace(' result-info', '');
  }

  iconClick(iconData){
    // TEMP FIX
    if(iconData?.icon == 'favourite'){
      this.state.favouriteEnable = false;
    //   if(this.state.isAlreadyFav){
    //     return
    // }
    //   this.state.isAlreadyFav = true;
   
      this._processShellService.resultIconClick.emit({service:iconData?.service,resultData:this.state.resultData});
    }
  }

  onClose() {
    //reset Transfers ResultPage start
    if (this.state.resultData && this.state.resultData.backNavPath && this.state.resultData.backNavPath=='credit-card') {
      let module = 'transactions';

      const extras = this._processShellService.getInitialProcess();
      const additionalDetails = extras?.queryParams?.additionalDetails;
      this._processShellService.clearDraftProcess();
      this._commonService.isDesktop()?this._matDialog.closeAll():'';
      let backNavPath;
      if(this.state.resultData.backNavPath instanceof Array){
        backNavPath = this.state.resultData.backNavPath
      }else{
        backNavPath = ['home', module]
      }
      this._router.navigate(backNavPath, {
        queryParams: additionalDetails?.queryParams,
        queryParamsHandling: 'preserve'
      });
    } else{
      this.transfersResultPageService.resetTransfersResultPage();
    //reset Transfers ResultPage end
    
    this._router.navigate(['home', 'transfers'], {
      queryParams: {},
      queryParamsHandling: 'preserve'
    });
  }
  }
// temp Fix start
closeBtnLable(){
  if (this.state.resultData && this.state.resultData.backNavPath) {
    let module = '';
    if (this.accountsModules.includes(this.state.resultData.backNavPath)) module = 'transactions';
    else if (this.cardsModules.includes(this.state.resultData.backNavPath)) module = 'cards';
    else module = this.state.resultData.backNavPath;

    if(this.state.resultData.backNavPath instanceof Array){
      this.setbackLable(this.state.resultData.backNavPath[this.state.resultData.backNavPath.length-1])
    }else{
      this.setbackLable(module)
    }

  }else{
    this.state.closeBtnLable = 'Back To Home'
  }
}

setbackLable(module){
  if(module=='transfers'){
    this.state.closeBtnLable = 'Back To Transfers'
  }
  if(module=='transactions'){
    this.state.closeBtnLable = 'Back To Accounts'
  }
  if(module=='cards'){
    this.state.closeBtnLable = 'Back To Accounts'
  }
  if(module=='settings'){
    this.state.closeBtnLable = 'Back To Settings'
  }
  if(module=='mailbox'){
    this.state.closeBtnLable = 'Back To Mailbox'
  }
  if(module=='overview'){
    this.state.closeBtnLable = 'Back To Overview'
  }
}
// 2Z6
// downloadTransferReceipt(sourceReference: string, currentDateTime: string) {
//   this._transfersResultPageService.downloadTransferReceipt(sourceReference, currentDateTime).subscribe({
//     next: (response: any) => {
//       this._commonService.hideSpinner();
//       if (this._commonService.isHybrid()) {
//         this._fileOpner.openPDF(
//           response,
//           "application/pdf",
//           "Transfer receipt.pdf"
//         );
//       } else {
//         let documentURL = URL.createObjectURL(
//           new Blob([response.body], { type: "application/pdf" })
//         );
//         const downloadLink = document.createElement("a");
//         downloadLink.href = documentURL;
//         // const fileName = "Transfer receipt";
//         let fileName: string;

//         if (response.headers.get('filename') === 'International') {
//           const idcReferenceNumber = response.headers.get('refnum');
//           const date = new Date();
//           const year = date.getFullYear();
//           const month = (date.getMonth() + 1).toString().padStart(2, '0');
//           const day = date.getDate().toString().padStart(2, '0');
//           const formattedDate = `${year}${month}${day}`;

//           fileName = `TTOnline-${idcReferenceNumber}-${formattedDate}.pdf`;
//         } else {
//           fileName = "Transfer receipt";
//         }
//         downloadLink.download = fileName;
//         downloadLink.click();
//       }
//     },
//   });
// }

downloadTransferReceipt(sourceReference: string, currentDateTime: string) {
  this._transfersResultPageService.downloadTransferReceipt(sourceReference, currentDateTime).subscribe({
    next: (response: any) => {
      this._commonService.hideSpinner();

      let fileName: string;
      if (response.headers.get('filename') === 'International') {
        const idcReferenceNumber = response.headers.get('refnum');
        const date = new Date();
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const day = date.getDate().toString().padStart(2, '0');
        const formattedDate = `${year}${month}${day}`;

        fileName = `TTOnline-${idcReferenceNumber}-${formattedDate}.pdf`;
      } else if (response.headers.get('filename') === 'DomesticPayment_Receipt') {
        const idcReferenceNumber = response.headers.get('refnum');
        const beneName = response.headers.get('beneName');
        const date = new Date();
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const day = date.getDate().toString().padStart(2, '0');
        const formattedDate = `${year}${month}${day}`;

        fileName = `DOM_${formattedDate}_${beneName}_${idcReferenceNumber}.pdf`;
      }
      else if (response.headers.get('filename') === 'WithinBank_Receipt') {
        const idcReferenceNumber = response.headers.get('refnum');
        const beneName = response.headers.get('beneName');
        const date = new Date();
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const day = date.getDate().toString().padStart(2, '0');
        const formattedDate = `${year}${month}${day}`;

        fileName = `INB_${formattedDate}_${beneName}_${idcReferenceNumber}.pdf`;
      }
      else if (response.headers.get('filename') === 'OwnAccount_Receipt') {
        const idcReferenceNumber = response.headers.get('refnum');
        const accNum = response.headers.get('accNum');
        const date = new Date();
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const day = date.getDate().toString().padStart(2, '0');
        const formattedDate = `${year}${month}${day}`;

        fileName = `OAT_${formattedDate}_${accNum}_${idcReferenceNumber}.pdf`;
      }
      else if (response.headers.get('filename') === 'PayToPayID_Receipt') {
        const idcReferenceNumber = response.headers.get('refnum');
        const payId = response.headers.get('payId');
        const date = new Date();
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const day = date.getDate().toString().padStart(2, '0');
        const formattedDate = `${year}${month}${day}`;

        fileName = `PAYID_${formattedDate}_${payId}_${idcReferenceNumber}.pdf`;
      }
      else {
        fileName = "Transfer receipt.pdf";
      }
      if (this._commonService.isHybrid()) {
        this._fileOpner.openPDF(
          response,
          "application/pdf",
          fileName
        );
      } else {
        // For desktop applications
        let documentURL = URL.createObjectURL(
          new Blob([response.body], { type: "application/pdf" })
        );
        const downloadLink = document.createElement("a");
        downloadLink.href = documentURL;
        downloadLink.download = fileName;
        downloadLink.click();

        URL.revokeObjectURL(documentURL);
      }
    },
    error: (error: any) => {
      this._commonService.hideSpinner();
      console.error('Error downloading transfer receipt:', error);
    }
  });
}

// temp Fix end
}
